import {SportIDs} from "./sport";

export const marketTypes = {
  // Market types.
  MT_1X2_ID: 1,  // 1X2
  MT_OU_ID: 2,  // Over/Under
  MT_AH_ID: 3,  // Asian Handicap
  MT_EH_ID: 4,  // Euro Handicap
  MT_DC_ID: 5,  // Double Chance
  MT_DNB_ID: 6,  // Draw No Bet
  MT_BTS_ID: 7,  // Both Teams to Score
  MT_HT_FT_ID: 8,  // Half Time/Full Time
  MT_O_E_ID: 9,  // Odd/Even
  MT_CS_ID: 10,  // Correct Score
  MT_ANY_ID: 11,  // Anytime Goalscorer
  MT_1ST_ID: 12,  // First Goalscorer
  MT_LAST_ID: 13,  // Last Goalscorer
  MT_12_ID: 14,  // 12
  MT_OR: 17, //Outright
  MT_SPECIAL: 19, //Special
  MT_TS: 28, // Top scorer
  MT_SW: 29, //Stage Winner
  MT_TW: 30, // Tournament winner
  MT_WSC: 32, // Winner Sprint Classification
  MT_WMC: 33, // Winner Mountains Classification
  MT_WYRC: 34, // Winner Young Rider Classification
  MT_WTC: 35, // Winner Teams Classification
  MT_R: 36, // Relagation
  MT_TOP_X: 37, // Top X
  MT_HNB_ID: 38,  // Home No Bet
  MT_ANB_ID: 39,  // Away No Bet
  MT_WPC: 41, // Winner Points Classification
  MT_VP: 42, // Votes Percentage
  MT_EP: 43, // Event Period
  MT_FTW: 44, // First Time Winner
  MT_TRF: 45, // To Reach Final
  MT_TRSF: 46, // To Reach Semi Final
  MT_TRQF: 47, // To Reach Quarter Final
  MT_TASS: 48, // Top Assists
  MT_BYP: 49, // Best Young Player
  MT_GBA: 50, // Golden Ball
  MT_GGL: 51, // Golden Glove
  MARKET_TYPES_WITH_LINES: [2, 3, 4],
  MARKET_TYPES_WITH_PLAYER: [11, 12, 13],
}

export function getMarketTypeIdsBySportId(sportId?: number): number[] {
  switch (sportId) {
    case SportIDs.Football:
      return [
        marketTypes.MT_1X2_ID, marketTypes.MT_OU_ID, marketTypes.MT_AH_ID, marketTypes.MT_EH_ID, marketTypes.MT_DC_ID,
        marketTypes.MT_DNB_ID, marketTypes.MT_BTS_ID, marketTypes.MT_ANY_ID, marketTypes.MT_1ST_ID,
      ];

    case SportIDs.Handball:
      return [marketTypes.MT_1X2_ID, marketTypes.MT_OU_ID, marketTypes.MT_AH_ID, marketTypes.MT_EH_ID];

    case SportIDs.Tennis:
      return [marketTypes.MT_12_ID, marketTypes.MT_OU_ID];

    case SportIDs.IceHockey:
    case SportIDs.Hockey:
      return [marketTypes.MT_1X2_ID, marketTypes.MT_12_ID, marketTypes.MT_OU_ID, marketTypes.MT_AH_ID, marketTypes.MT_EH_ID];

    case SportIDs.Basketball:
      return [marketTypes.MT_12_ID, marketTypes.MT_1X2_ID, marketTypes.MT_OU_ID, marketTypes.MT_AH_ID, marketTypes.MT_EH_ID, marketTypes.MT_DC_ID];

    case SportIDs.AmericanFootball:
      return [marketTypes.MT_12_ID, marketTypes.MT_1X2_ID, marketTypes.MT_OU_ID, marketTypes.MT_AH_ID, marketTypes.MT_EH_ID, marketTypes.MT_DNB_ID];

    case SportIDs.Esports:
      return [marketTypes.MT_12_ID, marketTypes.MT_1X2_ID, marketTypes.MT_AH_ID, marketTypes.MT_EH_ID, marketTypes.MT_DNB_ID];

    case SportIDs.Baseball:
      return [marketTypes.MT_12_ID, marketTypes.MT_OU_ID, marketTypes.MT_AH_ID];

    default:
      return [marketTypes.MT_12_ID];
  }
}


export function getMarketTypeShortName(marketTypeId: number): string {
  switch (marketTypeId) {

    case marketTypes.MT_1X2_ID:
      return '1X2';
    case marketTypes.MT_OU_ID:
      return 'OU';
    case marketTypes.MT_AH_ID:
      return 'AH';
    case marketTypes.MT_EH_ID:
      return 'EH';
    case marketTypes.MT_DC_ID:
      return 'DC';
    case marketTypes.MT_DNB_ID:
      return 'DNB';
    case marketTypes.MT_BTS_ID:
      return 'BTS';
    case marketTypes.MT_HT_FT_ID:
      return 'HT/FT';
    case marketTypes.MT_1ST_ID:
      return '1ST';
    case marketTypes.MT_LAST_ID:
      return 'LAST';
    case marketTypes.MT_12_ID:
      return '12';
    case marketTypes.MT_O_E_ID:
      return 'OE';
    case marketTypes.MT_CS_ID:
      return 'CS';
    case marketTypes.MT_ANY_ID:
      return 'ANY';
    case marketTypes.MT_OR:
      return 'OR';
    case marketTypes.MT_SPECIAL:
      return 'SPECIAL';
    case marketTypes.MT_TS:
      return 'TS';
    case marketTypes.MT_SW:
      return 'SW';
    case marketTypes.MT_TW:
      return 'TW';
    case marketTypes.MT_WSC:
      return 'WSC';
    case marketTypes.MT_WMC:
      return 'WMC';
    case marketTypes.MT_WYRC:
      return 'WYRC';
    case marketTypes.MT_WTC:
      return 'WTC';
    case marketTypes.MT_R:
      return 'REL';
    case marketTypes.MT_TOP_X:
      return 'TOPX';
    case marketTypes.MT_HNB_ID:
      return 'HNB';
    case marketTypes.MT_ANB_ID:
      return 'ANB';
    case marketTypes.MT_WPC:
      return 'WPC';
    case marketTypes.MT_VP:
      return 'VP';
    case marketTypes.MT_EP:
      return 'EP';
    case marketTypes.MT_FTW:
      return 'FWT';
    case marketTypes.MT_TRF:
      return 'TRF';
    case marketTypes.MT_TRSF:
      return 'TRSF';
    case marketTypes.MT_TRQF:
      return 'TRQF';
    case marketTypes.MT_TASS:
      return 'TASS';
    case marketTypes.MT_BYP:
      return 'BYP';
    case marketTypes.MT_GBA:
      return 'GBA';
    case marketTypes.MT_GGL:
      return 'GGL';
  }

  return 'Market ' + marketTypeId;
}

export function getMarketTypeFullName(marketTypeId: number): string {
  switch (marketTypeId) {
    case marketTypes.MT_1X2_ID:
      return '1X2';
    case marketTypes.MT_OU_ID:
      return 'Over/Under';
    case marketTypes.MT_AH_ID:
      return 'Asian Handicap ';
    case marketTypes.MT_EH_ID:
      return 'Euro Handicap';
    case marketTypes.MT_DC_ID:
      return 'Double Chance';
    case marketTypes.MT_DNB_ID:
      return 'Draw No Bet';
    case marketTypes.MT_BTS_ID:
      return 'Both Teams to Score';
    case marketTypes.MT_HT_FT_ID:
      return 'Half Time/Full Time';
    case marketTypes.MT_ANY_ID:
      return 'Anytime Goalscorer';
    case marketTypes.MT_1ST_ID:
      return 'First Goalscorer';
    case marketTypes.MT_LAST_ID:
      return 'Last Goalscorer';
    case marketTypes.MT_12_ID:
      return '12';
    case marketTypes.MT_TW:
      return 'Tournament Winner';
    case marketTypes.MT_OR:
      return 'Outright';
    case marketTypes.MT_SPECIAL:
      return 'Special';
    case marketTypes.MT_TS:
      return 'Top scorer';
    case marketTypes.MT_SW:
      return 'Stage Winner';
    case marketTypes.MT_WSC:
      return 'Winner Sprint Classification';
    case marketTypes.MT_WMC:
      return 'Winner Mountains Classification';
    case marketTypes.MT_WYRC:
      return 'Winner Young Rider Classification';
    case marketTypes.MT_WTC:
      return 'Winner Teams Classification';
    case marketTypes.MT_R:
      return 'Relagation';
    case marketTypes.MT_TOP_X:
      return 'Top X';
    case marketTypes.MT_HNB_ID:
      return 'Home No Bet';
    case marketTypes.MT_ANB_ID:
      return 'Away No Bet';
    case marketTypes.MT_WPC:
      return 'Winner Points Classification';
    case marketTypes.MT_VP:
      return 'Votes Percentage';
    case marketTypes.MT_EP:
      return 'Event Period';
    case marketTypes.MT_FTW:
      return 'First Time Winner';
    case marketTypes.MT_TRF:
      return 'To Reach Final';
    case marketTypes.MT_TRSF:
      return 'To Reach Semi Final';
    case marketTypes.MT_TRQF:
      return 'To Reach Quarter Final';
    case marketTypes.MT_TASS:
      return 'Top Assists';
    case marketTypes.MT_BYP:
      return 'Best Young Player';
    case marketTypes.MT_GBA:
      return 'Golden Ball';
    case marketTypes.MT_GGL:
      return 'Golden Glove';
  }

  return 'Market ' + marketTypeId;
}

export default marketTypes;
